import e from"react";import r from"antd/lib/form";const t=e=>"string"==typeof e?e.trimStart():e,a=({loading:a,valuePropName:o,normalize:m=t,...i})=>e.createElement(r.Item,{valuePropName:a?"v":o,normalize:m,...i});export{a as default};
//# sourceMappingURL=FormItem.js.map
